import moment from "moment";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";

import { getDisablePreviousDates, getButtonBgColor, getFontFamily, getAvailableDates, getFilterDates } from "slices";

const DayShow = ({ focusedDate, onClickDate, selectedDate }) => {
  const disablePreviousDates = useSelector(getDisablePreviousDates);
  const availableDates = useSelector(getAvailableDates);
  const isFilterDates = useSelector(getFilterDates);
  const color = useSelector(getButtonBgColor);
  const fontFamily = useSelector(getFontFamily);

  const generateCalendar = (month, year) => {
    const daysInMonth = moment(`${year}-${month}`, "YYYY-M").daysInMonth(); // or getDaysInMonth(new Date(year, month))
    const firstDayOfWeek = moment(`${year}-${month}-01`, "YYYY-M-D").day(); // or getDay(new Date(year, month, 1))

    // generate an array of date objects for the days in the month
    const dates = Array.from({ length: daysInMonth }, (_, i) => moment(`${year}-${month}-${i + 1}`, "YYYY-M-D")); // or Array.from({ length: daysInMonth }, (_, i) => new Date(year, month, i + 1))

    // pad the start of the array with null values for days before the first of the month
    for (let i = 0; i < firstDayOfWeek; i++) {
      dates.unshift(null);
    }

    // pad the end of the array with null values for days after the last of the month
    const lastDayOfWeek = dates[dates.length - 1].day();

    for (let i = lastDayOfWeek; i < 6; i++) {
      dates.push(null);
    }

    return dates;
  };

  const calendar = generateCalendar(focusedDate.month() + 1, focusedDate.year());

  return (
    <>
      {/* Rendering week days */}
      <div className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50">
        Su
      </div>
      <div className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50">
        Mo
      </div>
      <div className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50">
        Tu
      </div>
      <div className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50">
        We
      </div>
      <div className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50">
        Th
      </div>
      <div className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50">
        Fr
      </div>
      <div className="hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-text-xs hayley-font-semibold hayley-text-secondary/50">
        Sa
      </div>
      {/* Rendering dates */}
      {calendar.map((date, i) => {
        if (!date) {
          return (
            <div
              key={i}
              className="hayley-flex hayley-h-9 hayley-w-9 hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-border-none hayley-bg-white hayley-font-opensans"
            />
          );
        }

        return (
          <Button
            key={i}
            data-testid="calendar-date"
            className={`hayley-custom hayley-flex hayley-h-9 hayley-min-h-fit hayley-w-9 hayley-min-w-fit hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-rounded-none hayley-border hayley-border-solid hayley-border-transparent hayley-font-opensans hayley-text-sm hayley-text-secondary disabled:hayley-cursor-not-allowed disabled:hayley-text-secondary/40 disabled:hover:hayley-text-secondary/40 ${
              selectedDate === date.format("MMM DD, YYYY") ? "hayley-bg-secondary/10" : "hayley-bg-white"
            }`}
            sx={{
              "&.hayley-custom": {
                fontFamily: `${fontFamily} !important`,
                "&:hover": { borderColor: `${color} !important` },
              },
            }}
            onClick={() => onClickDate(date)}
            disabled={
              (disablePreviousDates && date.isBefore(moment().subtract(1, "day"))) || (isFilterDates && !availableDates.includes(date.format("YYYY-MM-DD")))
            }
          >
            {date.date()}
          </Button>
        );
      })}
    </>
  );
};

export default DayShow;
